import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Play(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.565 3.002a.572.572 0 00-.284.078.552.552 0 00-.281.487v16.515a.55.55 0 00.281.487c.084.05.308.147.562 0l14.303-8.257a.553.553 0 00.281-.487.552.552 0 00-.281-.487L4.843 3.08a.553.553 0 00-.278-.078m-.003 19.646c-.44 0-.88-.115-1.281-.346A2.536 2.536 0 012 20.082V3.567c0-.926.478-1.755 1.281-2.22a2.534 2.534 0 012.562 0l14.303 8.259a2.536 2.536 0 011.281 2.219 2.539 2.539 0 01-1.281 2.219L5.843 22.302a2.56 2.56 0 01-1.281.346",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoPlay = React.memo(Play);
export default MemoPlay;